import React from 'react';
import { Typography, Space, Input, Upload, Button, message, Divider } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { TextArea } = Input;

const InspectorPanel = ({ formValues, onFormChange, onLogoUpload, onRemoveLogo }) => {

  const handleLogoUpload = (options) => {
    const { file, onSuccess, onError } = options;

    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG files!');
        onError(new Error('Invalid file type'));
        return;
    }

    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
        message.error('Image must be smaller than 1MB!');
        onError(new Error('File too large'));
        return;
    }

    // Hand over to the parent to do the actual network request
    if (onLogoUpload) {
        onLogoUpload(file, onSuccess, onError);
    } else {
        onError(new Error("No upload handler provided."));
    }
  };

  const handleRemoveLogo = () => {
    if (onRemoveLogo) {
        onRemoveLogo();
    }
  };

  return (
    <div style={{ width: 340, borderLeft: '1px solid #e5e7eb', overflowY: 'auto', background: '#fff', padding: '4px 16px' }}>
      <Title level={5} style={{ marginBottom: 16 }}>Content Variables</Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        Update the content below to automatically generate your printable hiring sign.
      </Text>

      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        
        {/* Logo Section */}
        <div>
          <Text strong>Company Logo</Text>
          <div style={{ marginTop: 8 }}>
            {formValues.logoUrl ? (
              <div style={{ position: 'relative', display: 'inline-block', border: '1px solid #e5e7eb', borderRadius: 4, padding: 8, background: '#fafafa' }}>
                <img 
                  src={formValues.logoUrl} 
                  alt="Company Logo" 
                  style={{ maxWidth: '100%', maxHeight: 80, objectFit: 'contain' }} 
                />
                <Button 
                    type="primary" 
                    danger 
                    size="small" 
                    icon={<DeleteOutlined />} 
                    onClick={handleRemoveLogo} 
                    style={{ position: 'absolute', top: -10, right: -10 }}
                />
              </div>
            ) : (
              <Upload
                name="file"
                multiple={false}
                accept="image/jpeg,image/png"
                customRequest={handleLogoUpload}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>Click to Upload Logo</Button>
                <div style={{ marginTop: 8 }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>(Max size: 1MB, JPG/PNG)</Text>
                </div>
              </Upload>
            )}
          </div>
        </div>

        <Divider style={{ margin: 0 }} />

        {/* Brand Name */}
        <div>
          <Text strong>Brand / Headline</Text>
          <Input 
            style={{ marginTop: 8 }} 
            value={formValues.brandName} 
            onChange={(e) => onFormChange('brandName', e.target.value)} 
            placeholder="e.g. We're Hiring!"
          />
        </div>

        {/* Sub Heading */}
        <div>
          <Text strong>Sub Heading</Text>
          <TextArea 
            style={{ marginTop: 8 }} 
            rows={3} 
            value={formValues.subHeading} 
            onChange={(e) => onFormChange('subHeading', e.target.value)} 
            placeholder="e.g. Join our team today..."
          />
        </div>

        {/* Career Site URL */}
        <div>
          <Text strong>Career Site URL <Text type="secondary">(Optional)</Text></Text>
          <Input 
            style={{ marginTop: 8 }} 
            value={formValues.careerSiteUrl} 
            onChange={(e) => onFormChange('careerSiteUrl', e.target.value)} 
            placeholder="e.g. careers.company.com"
          />
        </div>

        {/* Disclaimer Text */}
        <div>
          <Text strong>Disclaimer Text</Text>
          <TextArea 
            style={{ marginTop: 8 }} 
            rows={3} 
            value={formValues.disclaimer} 
            onChange={(e) => onFormChange('disclaimer', e.target.value)} 
            placeholder="e.g. Message and data rates may apply."
          />
        </div>

      </Space>
    </div>
  );
};

export default InspectorPanel;
